import { useTranslation } from 'react-i18next';

import { copyToClipboard } from '@saas-kit/lib';
import { Button, Card, CardContent, FormBanner, toast } from '@saas-kit/ui';

import type { RevealedLink } from './useDisplays';

/** One-time reveal of a display's signed public link, shown after create/rotate. */
export function DisplayLinkCard({
  link,
  onDismiss,
}: {
  link: RevealedLink;
  onDismiss: () => void;
}): JSX.Element {
  const { t } = useTranslation('qms');

  const copy = async (): Promise<void> => {
    if (await copyToClipboard(link.url)) {
      toast.success(t('displays.copied'));
    } else {
      toast.error(t('displays.copy_failed'));
    }
  };

  return (
    <Card>
      <CardContent className="space-y-3 p-5">
        <FormBanner variant="info">{t('displays.link_body')}</FormBanner>
        <p className="text-sm font-medium text-foreground">{link.name}</p>
        <code className="block overflow-x-auto rounded-md bg-muted px-3 py-2 text-xs text-foreground">
          {link.url}
        </code>
        <div className="flex flex-wrap gap-2">
          <Button onClick={() => void copy()}>{t('displays.copy')}</Button>
          <Button
            variant="ghost"
            onClick={() =>
              window.open(link.url, '_blank', 'noopener,noreferrer')
            }
          >
            {t('displays.open')}
          </Button>
          <Button variant="ghost" onClick={onDismiss}>
            {t('confirm.cancel')}
          </Button>
        </div>
      </CardContent>
    </Card>
  );
}
